export default __webpack_public_path__ + "static/media/ouWM-AyiNxM.d84b166e.jpg";